import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { Stock } from '../interfaces/stock.interface';
import { Router } from '@angular/router'; 
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class StockService {
    private getstocksUrl = environment.apiUrl + '/handlers/stockgetall.php';  // URL to web api
    private updatestockUrl = environment.apiUrl + '/handlers/stockupdate.php';  // URL to web api
    private getstockUrl = environment.apiUrl + '/handlers/stockget.php';  // URL to web api
    private createstockUrl = environment.apiUrl + '/handlers/stockcreate.php';  // URL to web api
    private deletestockUrl = environment.apiUrl + '/handlers/stockdelete.php';  // URL to web api

    stocks: Stock[] = [];
    selectedStock: Stock = {} as Stock;

  constructor(private http: HttpClient, private router: Router) { }

     async getStocks(): Promise<Stock[]> 
      {
        let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
              throw new Error('Not logged in');
        }
        let user = JSON.parse(cuser);
        let distid = user['distid'];
        const data$ = this.http.post<Stock[]>(this.getstocksUrl,JSON.stringify({ distid: distid }));
        try {
          this.stocks = await firstValueFrom(data$);
          return this.stocks;
        }
        catch (error) {
          console.error('Get all stocks service!', error);
          throw error;
        };  
      }

async create(productcode: string, warehousecode:string, stockdate:string, volume:number, volumeid:string, value:number, allocatedvolume:number, producttype: string, uploaded:string): Promise<any> {
    let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
          throw new Error('Not logged in');
        }
    let user = JSON.parse(cuser);
    let distid = user['distid'];

    const data$ = this.http.post(this.createstockUrl, JSON.stringify({productcode: productcode, warehousecode:warehousecode, stockdate:stockdate, volume:volume, volumeid:volumeid, value:value, allocatedvolume:allocatedvolume, producttype: producttype, uploaded:uploaded,distid:distid}))
         try {
           let x = await firstValueFrom(data$);
           return x;
         }
         catch (error) {
           console.error(
             'Error in create stock service!', error);
             return;
         };  
  }

     async updateStock(productcode: string, warehousecode:string, stockdate:string, volume:number, volumeid:string, value:number, allocatedvolume:number, producttype: string, uploaded:string, id: number): Promise<void> {
        let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
          throw new Error('Not logged in');
        }
        let user = JSON.parse(cuser);
        let distid = user['distid'];
        try {
          const response$ = await firstValueFrom(this.http.post(this.updatestockUrl, JSON.stringify({productcode: productcode, warehousecode:warehousecode, stockdate:stockdate, volume:volume, volumeid:volumeid, value:value, allocatedvolume:allocatedvolume, producttype: producttype, uploaded:uploaded,distid:distid,id:id})));
           //return response$;
           return;
        }
        catch (error) {
          console.error(
            'Update Stock Servcie error!S', error);
            throw error;
        };
    }

   async deleteStock(id: number): Promise<void> {
        let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
          throw new Error('Not logged in');
        }
        let user = JSON.parse(cuser);
        let distid = user['distid'];
try 
    {
      const data$ = await this.http.post(this.deletestockUrl,JSON.stringify({id: id, distid: distid }))
      let response = await firstValueFrom(data$);
      return;
    }
    catch (error) 
    {
      console.error(
              'Delete Invoice Service Error: ', error);
              throw error;
    };  
   }  

     async get(id: number): Promise<Stock> 
      {
        let cuser = localStorage.getItem('currentUser');
        if (cuser === null) {
              throw new Error('Not logged in');
        }
        let user = JSON.parse(cuser);
        let distid = user['distid'];
        const data$ = this.http.post<Stock[]>(this.getstockUrl,JSON.stringify({ id: id }));
        try {
          this.selectedStock = (await firstValueFrom(data$))[0];
          return this.selectedStock;
        }
        catch (error) {
          console.error('Get stock service!', error);
          throw error;
        };  
      }


}
